import type { Page as PageType } from 'src/types/page';
import { ServicePage } from 'src/sections/services/service-page';

const Page: PageType = () => (
  <ServicePage
    seoTitle="Video Production & Content | Mystic Media Film"
    seoDescription="Cinematic video production and content from Mystic Media Film. Houston-based crew, multi-channel cuts, and a process built around delivering on deadline."
    service="Content"
    eyebrow="Content — 2026"
    headline="Content people"
    accent="actually watch."
    sub="Video, photo, and copy that earns attention and keeps it."
    description="Full-service production — from idea to export. |Scripted, shot, edited, and delivered ready for every channel."
    deliverables={[
      { num: '01', title: 'Video Production', body: 'Commercials, reels, hype videos, and brand stories — end to end.' },
      { num: '02', title: 'Photography', body: 'Product, lifestyle, and team shoots with a unified look.' },
      { num: '03', title: 'Copywriting', body: 'Scripts, web copy, emails, and ads that sound like you.' },
      { num: '04', title: 'Social Assets', body: 'Vertical cuts, thumbnails, and captions sized for every platform.' },
      { num: '05', title: 'Editing & Post', body: 'Color, sound, motion graphics, and cleanup in-house.' },
      { num: '06', title: 'Content Plans', body: 'Monthly calendars that keep the feed alive without burning out.' }
    ]}
    outcomes={['Sharp', 'On-brand', 'Multi-channel', 'Consistent']}
    process={[
      { num: '01', title: 'Plan', body: 'Concept, script, shot list, and locations locked before anyone touches a camera.' },
      { num: '02', title: 'Capture', body: 'Production day(s) on location or in studio with a tight crew and a clear plan.' },
      { num: '03', title: 'Edit', body: 'Color, sound, motion graphics, and platform-ready captions handled in-house.' },
      { num: '04', title: 'Deliver', body: 'Multi-format exports — horizontal, vertical, square — sized for every channel.' }
    ]}
    whyUs={[
      { title: 'Full in-house team', body: 'Strategy, scripting, production, and post all under one roof. No agency stacking, no farmed-out edits, no surprises in the invoice.' },
      { title: 'Multi-format from one shoot', body: 'We plan every shoot to produce horizontal, vertical, and square cuts — so one production day fuels weeks of content.' },
      { title: 'Built for the algorithm', body: 'Every cut ships with hooks, captions, and pacing tuned for the platforms your audience actually opens.' }
    ]}
    faqs={[
      { q: 'Do you handle scripting?', a: 'Yes — concept, script, and shot list are included. We can write from scratch or build on direction your team brings in.' },
      { q: "What's your turnaround?", a: '1–3 weeks from shoot to delivery, depending on scope and number of cuts. Rush turnarounds are available when the calendar allows.' },
      { q: 'Do you shoot on location?', a: 'Yes — anywhere your story needs to be told. We also have studio access for controlled product and interview shoots.' },
      { q: 'What gear do you use?', a: 'Cinema cameras, prime lenses, pro lighting, and broadcast-grade audio. The kit scales to match the project — not the other way around.' },
      { q: 'Can you cut for multiple platforms?', a: 'Every shoot ships in horizontal, vertical, and square cuts by default. Captions and platform-specific hooks are baked in.' },
      { q: 'Do you offer ongoing content packages?', a: 'Yes — monthly retainers cover a steady stream of video, photo, and copy. Most teams see results within 60 days.' }
    ]}
  />
);

export default Page;
